import React from "react";
import { Box } from "@chakra-ui/react";
import { LibraryListItem } from "./LibraryListItem";
import { List } from "../types";
import { RuleSourceById } from "../RuleRelationshipTags";

interface LibraryListProps {
	lists: List[];
	onEdit?: (list: List) => void;
	onDelete: (id: string) => void;
	onApply?: (list: List) => void;
	getApplyDisabledReason?: (list: List) => string | undefined;
	appliedListIds?: string[];
	applyingListId?: string;
	removingListId?: string;
	showEdit?: boolean;
	confirmDelete?: boolean;
	ruleSourceById?: RuleSourceById;
}

export const LibraryList = (props: LibraryListProps): JSX.Element => {
	const {
		lists,
		onEdit,
		onDelete,
		onApply,
		getApplyDisabledReason,
		appliedListIds = [],
		applyingListId,
		removingListId,
		showEdit = true,
		confirmDelete = true,
		ruleSourceById = {},
	} = props;

	return (
		<Box>
			{lists.map((list) => (
				<LibraryListItem
					key={list.id}
					list={list}
					onEdit={onEdit ? () => onEdit(list) : undefined}
					onDelete={() => onDelete(list.id)}
					onApply={onApply ? () => onApply(list) : undefined}
					applyDisabledReason={getApplyDisabledReason?.(list)}
					isApplied={appliedListIds.includes(list.id)}
					isApplying={applyingListId === list.id}
					isRemoving={removingListId === list.id}
					applyBusy={applyingListId !== undefined}
					removeBusy={removingListId !== undefined}
					showEdit={showEdit}
					confirmDelete={confirmDelete}
					ruleSourceById={ruleSourceById}
				/>
			))}
		</Box>
	);
};
